import { ScheduleDisplayModel } from "@/api/model-index";
import { AnfrageService } from "@/api/service-index";
import { PortalContextService } from "@/core/services/portal-context.service";
import { UnfinishedHttpMethodsService } from "@/core/services/unfinished-http-methods.service";
import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { of } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
  })
  export class GetAnfrageReportScheduleDataResolver implements Resolve<ScheduleDisplayModel | undefined> {
    constructor(protected anfrageService: AnfrageService, protected portalContextService: PortalContextService, protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService){}
  
    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ScheduleDisplayModel | undefined> {
      let id: string = <string>route.params['id'];
      let reportId: string = <string>route.params['reportid'];

      await this.unfinishedHttpMethodsService.waitByUrl(state.url);

      if(this.portalContextService.CurrentAnfrage && this.portalContextService.CurrentAnfrage.id == id && this.portalContextService.CurrentAnfrage.id && this.portalContextService.CurrentAnfrage.schedule)
        //if (!this.portalContextService.CurrentBericht || (this.portalContextService.CurrentBericht && this.portalContextService.CurrentBericht.projektberichtId == reportId))
        if (!this.portalContextService.CurrentBericht) // Todo: Caching is not working with berichte
          return of(this.portalContextService.CurrentAnfrage.schedule).toPromise();
        
      return this.anfrageService.apiAnfrageAnfrageIdScheduleGet({ anfrageId: id, reportId: reportId }).pipe(map(response => {
        if(response){
          if(this.portalContextService.CurrentAnfrage?.id == id && !this.portalContextService.CurrentAnfrage?.schedule || this.portalContextService.CurrentBericht)
            this.portalContextService.CurrentAnfrage.schedule = response;

          if(this.portalContextService.CurrentAnfrage?.schedule)
            return this.portalContextService.CurrentAnfrage.schedule;
        }

        return undefined;
      })).toPromise();
    }
  }